module.exports = __webpack_public_path__ + "static/video-1-763b07d9eb1f5e844e9b6dc22e15adee.png";